export default __webpack_public_path__ + "5abad8b2f62691f5416bb9f3611706ad.svg";